<script>
import StepText from "@/components/SignUp/Steps/StepText";

import { mapActions, mapState } from "vuex";
import errorMixin from "@/mixins/errorMixin";

export default {
  mixins: [errorMixin],

  components: {
    StepText
  },

  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: ""
    };
  },

  computed: {
    ...mapState("signUp", ["account", "fieldErrors", "accountableType"]),
    isPhysical() {
      return this.accountableType === "physical";
    }
  },

  methods: {
    ...mapActions("signUp", ["prevStep", "nextStep", "setAccount"]),
    async submit() {
      try {
        let dataIsValid = await this.$validator.validateAll();
        if (!dataIsValid) throw "Existem dados incorretos ou incompletos!";

        this.nextStep();
      } catch (e) {
        this.$toasted.error(e);
      }
    },

    store() {
      this.setAccount(this.$data);
    }
  },

  mounted() {
    document.querySelector("input").focus();
    this.inputErrors(this.fieldErrors);
    if (this.account) Object.assign(this.$data, this.account);
  },

  beforeDestroy() {
    this.store();
  }
};
</script>

<template>
  <form @submit.prevent="submit()">
    <step-text>Para começarmos o seu cadastro precisamos que você nos informe os dados da sua conta:</step-text>

    <template v-if="isPhysical">
      <base-input
        :error="errors.first('Nome')"
        v-validate="'required|min:2|alpha_spaces'"
        v-model="first_name"
        label="Nome"
        custom-classes="capitalize"
      />

      <base-input
        :error="errors.first('Sobrenome')"
        v-validate="'required|min:2|alpha_spaces'"
        v-model="last_name"
        label="Sobrenome"
        custom-classes="capitalize"
      />
    </template>

    <base-input
      :error="errors.first('email')"
      v-validate="'required|email'"
      v-model="email"
      label="E-mail"
      data-vv-as="E-mail"
      name="email"
      type="email"
    />

    <base-input
      :error="errors.first('Senha')"
      v-validate="'required|min:8'"
      v-model="password"
      label="Senha"
      type="password"
      ref="senha"
    />

    <base-input
      :error="errors.first('Confirme a senha')"
      v-validate="'required|min:8|confirmed:senha'"
      v-model="password_confirmation"
      label="Confirme a senha"
      type="password"
    />

    <base-flex justify="end" class="mt-10">
      <base-button @click="prevStep()" outlined>voltar</base-button>
      <base-button type="submit">continuar</base-button>
    </base-flex>
  </form>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Account.vue